import script from "./EventsReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventsReport.vue?vue&type=script&setup=true&lang=ts"

import "./EventsReport.vue?vue&type=style&index=0&id=55d4cd28&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55d4cd28"]])

export default __exports__